export const lightTheme = {
    mainColor: 'white',
    textColor: 'black',
    secondaryColor: '#FFF',
    accentColor: '#363537',
}
export const darkTheme = {
    mainColor: '#202020',
    textColor: '#AEBBC6',
    secondaryColor: '#232425',
    accentColor: '#999',
}

export type lightThemeType = typeof lightTheme;



